import React, { PropsWithChildren } from 'react';
import { MappedComponentProperties } from '@adobe/aem-react-editable-components';
import { transformHTMLParserLinks } from '../../utils/rewriteLink/rewriteLink';
import './EsignDisclosureTerms.css';

interface IEsignDisclosureTermsProps extends MappedComponentProperties {
  disclosure?: string
}

export const EsignDisclosureTermsEditConfig = {
    emptyLabel: 'Esign Disclosure Terms',
    isEmpty: (props: PropsWithChildren<IEsignDisclosureTermsProps>) => {
        return !props || !props.disclosure;
    },
};

const EsignDisclosureTerms = (props: PropsWithChildren<IEsignDisclosureTermsProps>): JSX.Element => {
    return (<div id='esign-disclosure-terms' className='EsignDisclosureTerms'>
        <section className='EsignDisclosureTerms__printSection'>
            <a onClick={() => window.print()} href='javascript:void(0);' className='EsignDisclosureTerms__printIcon'>
                <svg className='EsignDisclosureTerms__printSvg' aria-hidden='true' data-prefix='fal' data-icon='print' role='img' xmlns='http://www.w3.org/2000/svg' viewBox='0 0 512 512' data-fa-i2svg=''><path fill='currentColor' d='M432 192h-16v-82.75c0-8.49-3.37-16.62-9.37-22.63L329.37 9.37c-6-6-14.14-9.37-22.63-9.37H126.48C109.64 0 96 14.33 96 32v160H80c-44.18 0-80 35.82-80 80v96c0 8.84 7.16 16 16 16h80v112c0 8.84 7.16 16 16 16h288c8.84 0 16-7.16 16-16V384h80c8.84 0 16-7.16 16-16v-96c0-44.18-35.82-80-80-80zM320 45.25L370.75 96H320V45.25zM128.12 32H288v64c0 17.67 14.33 32 32 32h64v64H128.02l.1-160zM384 480H128v-96h256v96zm96-128H32v-80c0-26.47 21.53-48 48-48h352c26.47 0 48 21.53 48 48v80zm-80-88c-13.25 0-24 10.74-24 24 0 13.25 10.75 24 24 24s24-10.75 24-24c0-13.26-10.75-24-24-24z'></path></svg>
            </a>
        </section>
        {transformHTMLParserLinks(props.disclosure ?? '')}
    </div>);
};

export default EsignDisclosureTerms;
